import {
  Link as ReactRouterLink,
  LinkProps as ReactRouterLinkProps,
  matchPath,
  useHistory,
} from 'react-router-dom';
import classNames from 'classnames';

import * as SPA_PATHES from '@urls';

// styles
import s from './Link.sss';

// types
export type CommonProps = {
  theme?: keyof typeof themes;
  active?: boolean
};
export type AnchorProps = React.HTMLProps<HTMLAnchorElement>;
export type RouterLinkProps = ReactRouterLinkProps;
export type LinkProps = CommonProps & (AnchorProps | RouterLinkProps);

// consts
const themes = {
  green: s.themeGreen,
  black: s.themeBlack,
  dotted: s.themeDotted,
  clean: s.themeClean,
};

export const Link: React.FC<LinkProps> = ({
  theme,
  active,
  className,
  ...props
}) => {
  const history = useHistory();
  const classes = classNames(
    s.link,
    themes[theme || 'green'],
    { [s.active]: active },
    className,
  );

  if ('to' in props) {
    let pathname = '';
    let search: string | undefined;

    if (typeof props.to === 'string') {
      pathname = props.to;
    } else if ('pathname' in props.to && props.to.pathname) {
      pathname = props.to.pathname;
      search = props.to.search;
    }

    const match = matchPath(
      pathname,
      {
        path: Object.values(SPA_PATHES),
        exact: true,
      },
    );

    if (
      (
        typeof window === 'undefined'
        || window.IS_SPA_PAGE
      )
      && match
    ) {
      return (
        <ReactRouterLink
          className={classes}
          {...props}
        />
      );
    }

    const href = history.createHref({
      pathname,
      search,
    });

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { to, ...restProps } = props;

    return (
      <a
        className={classes}
        href={href}
        {...restProps}
      >
        {props.children}
      </a>
    );
  }

  return (
    <a className={classes} {...props}>
      {props.children}
    </a>
  );
};
